/*
 * AVALY confetti — tiny, dependency-free canvas confetti.
 * Exposes window.avalyConfetti(opts) where opts = {
 *   particleCount (default 80), spread (default 70), originY (0-1, default 0.5),
 *   scalar (size multiplier, default 1)
 * }
 * Respects prefers-reduced-motion (no-op for those users).
 */
(function () {
  'use strict';

  var COLORS = ['#ff4040', '#FFD93D', '#95b6ff', '#5a82cc', '#ffffff', '#ff8fa3'];
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function createCanvas() {
    var c = document.createElement('canvas');
    c.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:99999;';
    c.width = window.innerWidth;
    c.height = window.innerHeight;
    document.body.appendChild(c);
    return c;
  }

  window.avalyConfetti = function (opts) {
    opts = opts || {};
    if (reduceMotion) return;

    var count = opts.particleCount || 80;
    var spread = opts.spread || 70;
    var originY = typeof opts.originY === 'number' ? opts.originY : 0.5;
    var scalar = opts.scalar || 1;

    var canvas = createCanvas();
    var ctx = canvas.getContext('2d');
    var W = canvas.width;
    var H = canvas.height;
    var particles = [];
    var originX = W / 2;
    var startY = H * originY;

    for (var i = 0; i < count; i++) {
      var angle = (-90 + (Math.random() - 0.5) * spread) * (Math.PI / 180);
      var velocity = 6 + Math.random() * 8;
      particles.push({
        x: originX + (Math.random() - 0.5) * (W * 0.4),
        y: startY,
        vx: Math.cos(angle) * velocity,
        vy: Math.sin(angle) * velocity,
        size: (6 + Math.random() * 6) * scalar,
        color: COLORS[(Math.random() * COLORS.length) | 0],
        rot: Math.random() * Math.PI,
        vrot: (Math.random() - 0.5) * 0.3,
        life: 0,
        ttl: 90 + Math.random() * 40
      });
    }

    var frame = 0;
    function tick() {
      ctx.clearRect(0, 0, W, H);
      var alive = false;
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        if (p.life > p.ttl) continue;
        alive = true;
        p.life++;
        p.vy += 0.22; // gravity
        p.vx *= 0.99;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vrot;
        var opacity = Math.max(0, 1 - p.life / p.ttl);
        ctx.save();
        ctx.globalAlpha = opacity;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        ctx.restore();
      }
      frame++;
      if (alive && frame < 200) {
        requestAnimationFrame(tick);
      } else if (canvas.parentNode) {
        canvas.parentNode.removeChild(canvas);
      }
    }
    requestAnimationFrame(tick);
  };

  document.addEventListener('cart:item-added', function (event) {
    if (window.AVALY_SALE_ON) return;
    if (event && event.detail && event.detail.skipConfetti) return;
    window.avalyConfetti({ particleCount: 90, spread: 80, originY: 0.45, scalar: 1 });
  });
})();
